/**
 * Timer Store Module
 */

// Types
import * as types from '@/lib/store/types'
import config from '@/../config/app.json'


// State
const state = {
	timerStatus: 0,
	timerWarning: null,
	timerLogout: null
}

const actions = {

	[types.START_TIMER] ({commit}, dur)
	{
		commit(types.SET_TIMER, dur)
	},

	[types.WARN_TIMER] ({commit}, dur)
	{
		commit(types.SET_WARN, dur)
	},

	[types.CANCEL_TIMER] ({commit})
	{
		commit(types.UNSET_TIMER)
	},
}

const mutations = {

	[types.SET_TIMER] (state, dur)
	{
		state.timerStatus = 0
		state.timerLogout = clearTimeout(state.timerLogout)
		state.timerWarning = clearTimeout(state.timerWarning)

		state.timerWarning = setTimeout( () => {
			state.timerStatus = 1
		}, dur || config.app.sessionDuration)
	},

	[types.SET_WARN] (state, dur)
	{
		state.timerStatus = 1
		state.timerLogout = clearTimeout(state.timerLogout)
		state.timerLogout = setTimeout( () => {
			state.timerStatus = 2
		}, dur || config.app.resumeDuration)
	},

	[types.TIMER_STATUS] (state, status)
	{
		state.timerStatus = status
	},

	[types.UNSET_TIMER] (state)
	{
		state.timerWarning = clearTimeout(state.timerWarning)
		state.timerLogout = clearTimeout(state.timerLogout)
	},
}

const getters = {
	timerStatus: state => state.timerStatus
}


export default {
	state,
	actions,
	mutations,
	getters
}


// WEBPACK FOOTER //
// ./src/lib/store/modules/Timer.js